import { render } from "./ModalRegion.vue?vue&type=template&id=2895aa97"
import script from "./ModalRegion.vue?vue&type=script&lang=js"
export * from "./ModalRegion.vue?vue&type=script&lang=js"

import "./ModalRegion.vue?vue&type=style&index=0&id=2895aa97&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/ModalRegion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2895aa97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2895aa97', __exports__)) {
    api.reload('2895aa97', __exports__)
  }
  
  module.hot.accept("./ModalRegion.vue?vue&type=template&id=2895aa97", () => {
    api.rerender('2895aa97', render)
  })

}


export default __exports__